import type { RecipientAddress } from '@api-client/payments-webapi';
import type { AccountFlag, ContactFlag, SecondaryId } from '@api-client/address-book';

import type { DirectDebitTemplate, TransferTemplate } from './TransferTemplate';
import type { PublicContact } from './PublicContact';

export interface IsoAddress {
    id?: string;
    streetName?: string;
    buildingNumber?: string;
    department?: string;
    subDepartment?: string;
    buildingName?: string;
    floor?: string;
    room?: string;
    postBox?: string;
    postalCode?: string;
    townName?: string;
    townLocationName?: string;
    districtName?: string;
    country?: string;
    countrySubDivision?: string;
}

export enum CONTACT_IMPORT_SOURCE {
    ACCOUNT = 'ACCOUNT',
    GEORGE_API = 'GEORGE_API',
    TRANSACTION = 'TRANSACTION',
    TEMPLATE = 'TEMPLATE',
    MANDATE = 'MANDATE',
    TRANSIENT = 'TRANSIENT',
    NEW_TRANSFER = 'NEW_TRANSFER',
    STANDING_ORDER = 'STANDING_ORDER',
    REQUEST_TO_PAY = 'REQUEST_TO_PAY',
    DIRECT_DEBIT = 'DIRECT_DEBIT',
    MANUAL = 'MANUAL',
}

export enum ADDRESS_BOOK_ITEM_TYPE {
    BUSINESS_PARTNER = 'BUSINESS_PARTNER',
    CONTACT = 'CONTACT',
    TRANSFER_TEMPLATE = 'TRANSFER',
    SEPA_TRANSFER_TEMPLATE = 'SEPA_TRANSFER',
    NON_SEPA_TRANSFER_TEMPLATE = 'NON_SEPA_TRANSFER',
    SALARY_TRANSFER_TEMPLATE = 'SALARY_TRANSFER',
    PENSION_TRANSFER_TEMPLATE = 'PENSION_TRANSFER',
    TAX_TRANSFER_TEMPLATE = 'TAX_TRANSFER',
    DIRECT_DEBIT_TEMPLATE = 'DIRECT_DEBIT',
}

export interface Account {
    accountId?: string;
    secondaryId?: Partial<SecondaryId>;
    iban?: string;
    number?: string;
    prefix?: string;
    bic?: string;
    bankCode?: string;
    countryCode?: string;
}

export interface AddressBookItem {
    id: string;
    image?: string;
    contactId: string;
    name?: string;
    account?: Account;
    isoAddress?: RecipientAddress & { id?: string };
    address?: {
        id?: string;
        street?: string;
        city?: string;
        countryCode?: string;
    };
    restrictedViewAccess?: boolean;
    readOnly: boolean;
    trusted: boolean;
    trustedReadOnly: boolean;
    type: ADDRESS_BOOK_ITEM_TYPE;
    importSource: CONTACT_IMPORT_SOURCE;
    transfer?: TransferTemplate;
    directDebit?: DirectDebitTemplate;
    contactFlags?: ContactFlag[];
    flags?: AccountFlag[];
    favorite?: boolean;
}

export type AddressBookEntry = Partial<AddressBookItem> & Partial<PublicContact>;

export interface AddressBookInfo {
    contactId?: string;
}

export enum SCHEDULE_STATUS {
    ACTIVE = 'ACTIVE',
    ABOUT_TO_EXPIRE = 'ABOUT_TO_EXPIRE',
    EXPIRED = 'EXPIRED',
}
